import { useStore } from './useStore';

/**
 * Returns whether a feature flag is enabled for the current user.
 *
 * Usage:
 *   const isBidAnalysisEnabled = useFlag('bdportal.bid_analysis');
 */
export const useFlag = (key: string): boolean => {
  const { FeatureFlagStore } = useStore();
  return FeatureFlagStore.isEnabled(key);
};
